/*    
<summary>
   This typescript file contains special datatype that enables for a variale to be set of predefined constant.
   This constant is used in providing paths for API Route URL for every modules.
   Developer: Aashish Singh, Created Date: 08-Mar-2023
   UpdatedBy:Deepak Paliwal,Date: 23-March-2023
</summary>
*/
const URLConstants = {
   Authenticate: '/Account/Login',
   TwoStepVerification: '/Account/TwoStepVerification',
   ResendTwoStepVerificationOTP: '/Account/TwoStepVerification/Resend/OTP',
   Logout: '/Account/Logout',
   LoginReset: '/Account/Login/Reset',
   RefreshToken: '/Account/Token',
   AddConfiguration: '/ConfigurationProtocol',
   UpdateConfiguration: '/ConfigurationProtocol',
   GetConfigurationById: '/ConfigurationProtocol',
   GetConfigurationGroupAssociatedInfo: '/ConfigurationProtocol/IsGroupAssociated',
   DeleteConfiguration: '/ConfigurationProtocol',
   AddBulkDevice: '/Device/Bulk',
   AddBulkCSV: '/Device/CSV',
   Device: '/Device',
   DeleteAllDevice: '/Device/All',
   DeleteSelected: '/Device/Delete/Multiple',
   GetAllDevices: '/Device/List',
   ExportDevices: '/Device/Export',
   GetAllDevicesByFilter: '/Device/List/Tags/Filter',
   UpdateMultipleDevicesGroup: '/Device/Move/Multiple/Device',
   GetAllDevicesCount: '/Device/Summary/Count',
   GetAllPublishMessageCount: '/Device/All/Monthly/Published/Messages/Count',
   GetAllFailedPacketCount: 'Device/All/Monthly/FailedPacket/Count',
   TotalPacketsCount: '/Device/Total/Packets/Count',
   GetGroupById: '/Group',
   UpdateGroupIMEILockStatus: '/Group/Update/IMEILock/Status',
   GetGroupInfo: '/Group/GroupInfo',
   AddGroup: '/Group',
   UpdateGroup: '/Group',
   GetAllGroups: '/Group',
   UpdateDefaultGroup: '/Group/Update/Default',
   GetAllBlockedGroups: '/Group/Blocked',
   GetAllGroupsPaging: '/Group/List',
   DeleteGroup: '/Group',
   GroupUnblock: '/Group/Unblock',
   DeleteFiltered: '/Device/Delete/Filter',
   GetGroupDeviceAssociatedInfo: '/Group/IsDeviceAssociated',
   GetConfigurationList: '/ConfigurationProtocol/List',
   GetConfigurations: '/ConfigurationProtocol',
   Version: '/Version',
   GetUserList: '/User/List',
   User: '/User',
   UpdatePassword: '/Account/Update/User/Password',
   BlockedPasswordReset: '/Account/Blocked/User/Password/Reset',
   UserStatus: '/User/UserStatus',
   UpdateUserPassword: '/Account/Update/Password',
   BlockUserStatus: '/User/BlockStatus  ',
   Tenant: '/Tenant',
   UpdateTenantPassword: '/Account/Update/Tenant/Password',
   UpdateTenantStatus: '/Tenant/UpdateStatus',
   OneNceAccessToken: '/Device/OneNce/Token',
   OneNceDeviceSim: '/Device/OneNce/Sim',
   OneNceSimUsage: '/Device/OneNce/SimUsage',
   DeviceSimUsage: '/Device/SimUsage',
   OneNceSimStatus: '/Device/OneNce/SimStatus',
   OneNceSimReset: '/Device/OneNce/Sim/Reset',
   OneNceSimEnable: '/Device/OneNce/Sim/Enable',
   OneNceIMEILock: '/Device/OneNce/IMEILock',
   GetBillingList: '/Tenant/All/Bill/List',
   GetBillDetail: '/Tenant/Bill',
   CurrencyList: '/Tenant/Currency/List',
   GetTenantBill: '/Tenant',
   GenerateOrgId: '/Tenant/Generate/OrgId',
   AllMonthPacketCount: '/Device/All/Monthly/Packet/Count',
   AuditLog: '/AuditLog/List',
   AllAuditLogs: '/AuditLog',
   AuditLogDetail: '/AuditLog',
   UserExists: '/Account/User/Email/Verification',
   VerifyOTP: '/Account/User/OTP/Verification',
   PasswordReset: '/Account/User/Password/Reset',
   DumpLogs: '/DumpLog/List',
   GetPricingStats: '/Tenant/',
   PricingPlan: '/PricingPlan',
   GetPricingPlanList: '/GetPricingPlanList',
   Order: '/Order',
   AllTenantOrderList: '/Order/All/Tenants/List',
   OrderStatus: '/Order/Status',
   Role: '/Role',
   DeviceIccid: '/DeviceIccid',
   GetAllDeviceIccids: '/DeviceIccid/List',
   ExportDeviceIccids: '/DeviceIccid/Export',
   GetAllDeviceIccidsByFilter: '/DeviceIccid/List/Tags/Filter',
   UpdateMultipleDeviceIccidsGroup: '/DeviceIccid/Move/Multiple/DeviceIccid',
   DeleteAllDeviceIccid: '/DeviceIccid/Group',
   DeleteSelectedIccids: '/DeviceIccid/Delete/Multiple',
   AddBulkDeviceIccid: '/DeviceIccid/Bulk',
   AddBulkIccidCSV: '/DeviceIccid/CSV',
   RegisterDevice: '/RegisterDevice',
   RegisterDeviceSelected: '/RegisterDevice/Multiple',
   EmailExists: '/Account/SelfService/Tenant/Email/Verification',
   VerifyEmailOTP: '/Account/SelfService/Tenant/OTP/Verification',
   Statistics: '/Statistics',
   ActivateAccount: '/ActivateAccount',
   ResendLink: '/ResendLink',
   TrialTenant: '/Account/SelfService/Tenant',
   ActivateUser: '/Account/Tenant/User/Verification',
   AWSRegionList: '/AwsRegion',
   Fota: '/Fota',




   FotaModemRelease: '/Fota/Modem/Release',
   FotaModemReleaseList: '/Fota/Modem/Release/List',
   FotaModemScheduler: '/Fota/Modem/Scheduler',
   FotaModemReleaseScheduler: '/Fota/Modem/Release/Scheduler',
   FotaModemEffectedReleaseList: '/Fota/Modem/Effected/Release/List',

   FotaJetRelease: '/Fota/Jet/Release',
   FotaJetReleaseList: '/Fota/Jet/Release/List',
   FotaJetScheduler: '/Fota/Jet/Scheduler',
   FotaJetReleaseScheduler: '/Fota/Jet/Release/Scheduler',
   FotaJetEffectedReleaseList: '/Fota/Jet/Effected/Release/List',

   FotaHostRelease: '/Fota/Host/Release',
   FotaHostReleaseList: '/Fota/Host/Release/List',
   FotaHostScheduler: '/Fota/Host/Scheduler',
   FotaHostReleaseScheduler: '/Fota/Host/Release/Scheduler',

   FotaHostConfig: '/Fota/Host/Config',
   FotaModemConfig: '/Fota/Modem/Config',
   FotaJetConfig: '/Fota/Jet/Config',
   GetFotaHostConfigList: '/Fota/Host/Config/List',
   GetAllFotaHostConfig: '/Fota/Host/All/Config',
   GetAllFotaJetConfig: '/Fota/Jet/All/Effected/Config',
   GetAllFotaModemConfig: '/Fota/Modem/All/Effected/Config',

   GetFotaModemConfigList: '/Fota/Modem/Config/List',
   GetFotaJetConfigList: '/Fota/Jet/Config/List',
   // FotaHostScheduler:'/Fota/Host/Scheduler',
   GetFotaHostSchedulerList: '/Fota/Host/Scheduler/List',
   GetFotaHostSchedulerDevicesList: '/Fota/Host/Scheduler/Devices/List',
   GetFotaJetSchedulerDevicesList: '/Fota/Jet/Scheduler/Devices/List',
   GetFotaModemSchedulerDevicesList: '/Fota/Modem/Scheduler/Devices/List',
   GetAllFotaHostScheduler: '/Fota/Host/All/Scheduler',

   GetFotaJetSchedulerList: '/Fota/Jet/Scheduler/List',
   GetFotaModemSchedulerList: '/Fota/Modem/Scheduler/List',

   GetEffectedJetConfigList: '/Fota/Jet/Effected/Config/List',
   GetEffectedModemConfigList: '/Fota/Modem/Effected/Config/List',
}

export default URLConstants;